

import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { MutationStatus } from 'react-query';
import {
  ApiButton,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from 'web-library';

const useStyles = makeStyles()((theme) =>
({
  buttonContainer: {
    marginTop: theme.spacing(3),
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  boldContent: {
    fontWeight: 'bold',
  },
}));

interface DialogButtonsProps {
  onDialogClose: () => void;
  apiButtonClick: () => void;
  apiButtonStatus: MutationStatus;
}

const DialogButtons = ({ onDialogClose, apiButtonStatus, apiButtonClick }: DialogButtonsProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <DialogActions id="candidate-dialog-action">
      <Box className={classes.buttonContainer}>
        <Button id="button-cancel" onClick={onDialogClose} variant="text">
          {t('specialConsideration->>Dialog.Cancel')}
        </Button>
        <ApiButton
          id="button-proceed"
          status={apiButtonStatus}
          type="submit"
          onClick={apiButtonClick}
        >
          {t('exam->>Instructions.Proceed')}
        </ApiButton>
      </Box>
    </DialogActions>
  );
};

const DialogTitleContainer = () => {
  const { t } = useTranslation();
  return (
    <DialogTitle>
      <Typography variant="h4">
        {t('exam->>Instructions.ContinueApplicationDialogTitle')}
      </Typography>
    </DialogTitle>
  );
};

interface ConfirmNewAcademicDialogProps {
  modalState: boolean;
  onDialogClose: () => void;
  proceedClick: () => void;
  previousAcademicLevel: string;
  examLevel: string;
}

const ConfirmNewAcademicDialog = ({
  modalState,
  onDialogClose,
  proceedClick,
  examLevel,
  previousAcademicLevel,
}: ConfirmNewAcademicDialogProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <Dialog open={modalState} maxWidth="sm">
      <DialogTitleContainer />
      <DialogContent>
        <DialogContentText variant="body1">
          {t('exam->>Instructions.DialogContentStart')}
          <DialogContentText
            variant="body1"
            className={classes.boldContent}
            display="inline"
          >{`${examLevel} ${previousAcademicLevel}`}</DialogContentText>
          {t('exam->>Instructions.DialogContentEnd')}
        </DialogContentText>
      </DialogContent>
      <DialogButtons
        apiButtonStatus="idle"
        onDialogClose={onDialogClose}
        apiButtonClick={proceedClick}
      />
    </Dialog>
  );
};

export default ConfirmNewAcademicDialog;
